import { Store } from 'pullstate'

export type Customer = {
    id: string,
    name: string    
}

const CustomerStore = new Store({
    customers: [] as Customer[]
});

export { CustomerStore }
export default CustomerStore